/* StatusMessageComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./StatusMessageRenderer");

class StatusMessageComponent extends EventEmitter{
    constructor() {
        super();
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._messageHistory = [];
        this._showMessages = true;
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }
    toJSON(){
        let JSONObj = {};
        return JSONObj;
    }
    writeMessage(msg, isError){
        this._showMessages = true;
        this._messageHistory.push({msg: msg, isError: isError || false});
        this.renderer.render();
    }
    clear(){
        this._showMessages = false;
        this._messageHistory = [];
        this.renderer.render();
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=StatusMessageComponent;